export const PENDING = 'PENDING';
export const TRIAL = 'TRIAL';
export const INACTIVE = 'INACTIVE';
export const PRE_TRIAL = 'PRE_TRIAL';
export const ACTIVE = 'ACTIVE';

export const ALLOWED_STATUSES_FOR_TICKET_FILTER = [PRE_TRIAL, TRIAL, ACTIVE];
export const ALLOWED_STATUSES_FOR_ADMIN_PANEL = [PRE_TRIAL, TRIAL, ACTIVE];
export const ALLOWED_STATUSES_FOR_BLACKLIST = [PENDING, PRE_TRIAL, TRIAL, ACTIVE, INACTIVE];

export const STATUSES_TO_LOAD_FROM_DB = [PENDING, PRE_TRIAL, TRIAL, ACTIVE];
